import React, { useMemo, useState } from 'react';
import { Menu, MenuItem } from '@mui/material';

import { CopyBudgetWithNewClientModal } from 'components/pages/setup/Budget/BudgetList/CopyBudget/CopyBudgetWithNewClientModal/CopyBudgetWithNewClientModal';

import { copyStudyBudget } from '../../../../../../actions/finance/budget/copyStudyBudgetAction';
import modalBoxes from '../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../../common/general/Button';
import { MANAGE_BUDGETS } from '../../../../../../constants/userOperations';
import { userHasAccessTo } from '../../../../../../services/auth';

export const CopyBudget = ({ dispatch, id }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const isOpen = useMemo(() => Boolean(anchorEl), [anchorEl]);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const openCopyModal = () => {
    modalBoxes.open({
      component: <CopyBudgetWithNewClientModal budgetId={id} />,
      size: 'w350',
      className: 'copy-budget-modal',
      title: 'Copy Budget'
    });
  };

  return (
    <>
      {userHasAccessTo(MANAGE_BUDGETS) && (
        <>
          <Button size="h28" priority="high" onClick={handleClick}>
            Copy
          </Button>

          <Menu anchorEl={anchorEl} open={isOpen} onClose={() => setAnchorEl(null)}>
            <MenuItem
              id="copy-with-existing-client-option"
              onClick={() => {
                dispatch(copyStudyBudget(id));
                setAnchorEl(null);
              }}
            >
              Copy with existing client
            </MenuItem>
            <MenuItem
              id="copy-with-new-client-option"
              onClick={() => {
                openCopyModal();
                setAnchorEl(null);
              }}
            >
              Copy with a new client
            </MenuItem>
          </Menu>
        </>
      )}
    </>
  );
};
